import makeStyles from '@mui/styles/makeStyles';

const default_gray = "#667085";
const default_background_blue = "#EDF5FB";
const default_color_blue = "#308CDB";

const styles = makeStyles((theme) => ({
  mainDivInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    gap: "10px",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgb(0 0 0 / 20%)",
  },

  divImage: {
    width: "30%",
    height: "100%",
    display: "flex",
    alignItems: "center",

    "& img": {
      height: "100%",
    },
    "@media (max-width: 1390px)": {
      display: "none",
    },
  },
  button: {
    padding: "12px 20px",
  },
  menuItem: {
    font: "500 12px/24px Manrope",
    color: default_gray,
    "&:hover": {
      color: default_color_blue,
      backgroundColor: default_background_blue,
    },
  },
  shareMenu: {
    "& .MuiMenu-paper": {
      width: 180,
      left: 1106,
      borderRadius: 8,
    },
  },
}));

export default styles;
